module.exports = __webpack_public_path__ + "media/img/Landing_Page/goal-a56022b6c6722e7a47819308ebe4250e.jpg";